<template>
  <div class="about-us">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="6"></menuBox>
      <div class="banner-text">
        <div class="title">Hubungi kami, apakah Anda sedang berbelanja atau ingin mengekspor, kami menjamin kepuasan Anda</div>
      </div>
    </div>
    <div class="input-box">
      <input type="text" placeholder="Name">
      <input type="tel" placeholder="Telepon">
      <input type="Email" placeholder="Surel">
      <input type="text" placeholder="tema">
      <textarea type="text" name="" id="" placeholder="isi"></textarea>
      <div class="btn" @click="submit()">mengirim pesan</div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";
  export default {
    name: "App",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {
        name: "",
        email: "",
        message: "",
      };
    },
    mounted() { },
    methods: {
      submit() {
        alert("Submitted successfully");
      },
    },
  };
</script>
<style lang="less" scoped>
  .about-us {
    .banner-box {
      background-image: url(../assets/swiper-4.png);
      height: 620px;
      background-size: 100% 100%;

      .banner-text {
        margin: 0 360px;
        padding-top: 100px;
        text-align: left;
        margin-top: 20px;

        .title {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 50px;
          max-width: 600px;
          color: #333333;
        }

        .text {
          font-size: 26px;
          font-weight: 400;
          font-size: 22px;
          color: #333333;
          margin-top: 20px;
        }
      }
    }

    .input-box {
      padding: 100px 360px;

      input:nth-child(odd) {
        margin-right: 30px;
        margin-bottom: 16px;
      }

      input {
        background: #EBEFF3;
        border: none;
        width: 560px;
        padding-left: 15px;
        font-family: Helvetica;
        font-size: 18px;
        height: 50px;
        line-height: 50px;
      }

      textarea {
        width: 1165px;
        padding-left: 15px;
        height: 140px;
        background: #EBEFF3;
        border: none;
      }

      .btn {
        width: 100%;
        height: 64px;
        line-height: 64px;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 20px;
        color: #FFFFFF;
        background: #FAAD14;
        margin-top: 25px;
      }
    }

  }
</style>